import { Column } from '@zera-admin/page'
import PdfPageLayout from './PdfPageLayout'
import { TweetsByTimeAfter, TweetsCountBefore } from '../report-detail'

import { PdfPageProps } from './types'
import WordCloud from 'components/word-cloud'
import Icon from '@zera-admin/icon'
import { getMonthAndYear } from 'app/functions'

const PageFive: React.FunctionComponent<PdfPageProps> = ({ personReport }) => {
  return (
    <PdfPageLayout personReport={personReport}>
      <div style={{ width: '40vw', border: '1px solid grey' }}>
        <div style={{ width: '100%', textAlign: 'right', fontSize: '18px' }}>
          <p>{new Date(personReport.data.crawlingEndedAt).toLocaleString()} </p>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Column xs={{ size: 10 }}>
            <h2
              style={{
                display: 'flex',
                margin: 2,
                justifyContent: 'center',
                fontWeight: 500,
                color: '#4c5153',
                fontSize: 14,
              }}
            >
              2021 Sonrası Tweet Dağılımı (Aylık)
            </h2>
            <TweetsByTimeAfter
              data={personReport.data?.result?.Statistic?.tweetsByTimeAfter2021}
            />
          </Column>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Column xs={{ size: 10 }}>
            <h2
              style={{
                display: 'flex',
                margin: 2,
                justifyContent: 'center',
                fontWeight: 500,
                color: '#4c5153',
                fontSize: 14,
              }}
            >
              2021 Öncesi Tweet Dağılımı (Yıllık)
            </h2>
            <TweetsCountBefore
              data={personReport.data?.result?.Statistic?.tweetsCountBefore2021}
            />
          </Column>
        </div>
        <Column>
          <div style={{ width: '100%', textAlign: 'center', fontSize: '12px' }}>
            <Icon name="calendar" size="small" color="blue" />
            &nbsp;{getMonthAndYear(personReport.data.firstTweet)} - &nbsp;
            {getMonthAndYear(personReport.data.lastTweet)} arasındaki tweet
            akışı gösterilmektedir
          </div>
        </Column>
      </div>
      <div style={{ width: '40vw', border: '1px solid grey' }}>
        <div style={{ width: '100%', textAlign: 'right', fontSize: '18px' }}>
          <p>{new Date().toLocaleString()} </p>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Column xs={{ size: 12 }}>
            <h2
              style={{
                display: 'flex',
                margin: 2,
                justifyContent: 'center',
                fontWeight: 500,
                color: '#4c5153',
                fontSize: 14,
              }}
            >
              Word Cloud
            </h2>
            {/* <MostFollowedFollowers
                data={personReport.data?.result?.Statistic?.mostFollowedFollowers.slice(
                  0,
                  6
                )}
                columnSize={4}
              /> */}
            <WordCloud data={personReport.data?.result?.Statistic?.wordCloud} />
          </Column>
        </div>
        <Column>
          <div style={{ width: '100%', textAlign: 'center', fontSize: '12px' }}>
            <Icon name="calendar" size="small" color="blue" />
            &nbsp;{getMonthAndYear(personReport.data.firstTweet)} - &nbsp;
            {getMonthAndYear(personReport.data.lastTweet)} arasındaki tweet
            akışı gösterilmektedir
          </div>
        </Column>
      </div>
    </PdfPageLayout>
  )
}
export default PageFive
